import { render, staticRenderFns } from "./change.vue?vue&type=template&id=3a3f6ee4&scoped=true"
import script from "./change.vue?vue&type=script&lang=js"
export * from "./change.vue?vue&type=script&lang=js"
import style0 from "./change.vue?vue&type=style&index=0&id=3a3f6ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f6ee4",
  null
  
)

export default component.exports